
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_1lb7z_197",
  "arrow-outer": "awsui_arrow-outer_xjuzf_1lb7z_201",
  "arrow-inner": "awsui_arrow-inner_xjuzf_1lb7z_201",
  "refresh": "awsui_refresh_xjuzf_1lb7z_235",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_1lb7z_245",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_1lb7z_245",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_1lb7z_248",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_1lb7z_248",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_1lb7z_251",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_1lb7z_251",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_1lb7z_251",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_1lb7z_251",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_1lb7z_254",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_1lb7z_254",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_1lb7z_254",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_1lb7z_254",
  "body": "awsui_body_xjuzf_1lb7z_356",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_1lb7z_395",
  "has-dismiss": "awsui_has-dismiss_xjuzf_1lb7z_399",
  "dismiss": "awsui_dismiss_xjuzf_1lb7z_404",
  "dismiss-control": "awsui_dismiss-control_xjuzf_1lb7z_412",
  "header-row": "awsui_header-row_xjuzf_1lb7z_416",
  "header": "awsui_header_xjuzf_1lb7z_416",
  "content": "awsui_content_xjuzf_1lb7z_442",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_1lb7z_450",
  "container": "awsui_container_xjuzf_1lb7z_552",
  "container-body": "awsui_container-body_xjuzf_1lb7z_560",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_1lb7z_603",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_1lb7z_608",
  "fixed-width": "awsui_fixed-width_xjuzf_1lb7z_611",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_1lb7z_615",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_1lb7z_622",
  "container-arrow": "awsui_container-arrow_xjuzf_1lb7z_634",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_1lb7z_638",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_1lb7z_638",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_1lb7z_654",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_1lb7z_654",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_1lb7z_670",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_1lb7z_670",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_1lb7z_670",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_1lb7z_670",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_1lb7z_686",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_1lb7z_690",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_1lb7z_694",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_1lb7z_1",
  "root": "awsui_root_xjuzf_1lb7z_840",
  "trigger": "awsui_trigger_xjuzf_1lb7z_876",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_1lb7z_883",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_1lb7z_919"
};
  